import {
  base_colorAction,
  base_colorSurfaceSecondary,
  input_borderActive,
  input_borderDefault,
  input_borderHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const root = css`
  max-width: 100%;
  position: relative;
  width: ${spacing(140)};
`

export const composer = css`
  align-items: flex-start;
  display: flex;
  gap: ${spacing(3)};
  max-width: 100%;
  width: ${spacing(140)};
`

export const avatar = css`
  flex: 0 0 ${spacing(6)};
  margin-top: ${spacing(2.5)};
`

export const restComposer = css`
  align-items: flex-start;
  display: flex;
  gap: ${spacing(3)};
  max-width: 100%;
  width: ${spacing(140)};
`

export const restAvatar = css`
  flex: 0 0 ${spacing(6)};
`

export const restTrigger = css`
  align-items: center;
  align-self: stretch;
  background: ${base_colorSurfaceSecondary};
  border: 1px solid ${input_borderDefault};
  border-radius: ${cornerRadius};
  color: ${text_colorTextSecondary};
  cursor: pointer;
  display: flex;
  flex: 1 0 0;
  height: ${spacing(11)};
  justify-content: flex-start;
  min-width: 0;
  padding: 0 ${spacing(5)};
  position: relative;
  text-align: left;

  &:hover {
    border-color: ${input_borderHover};
  }

  &:focus-visible {
    border-color: ${input_borderActive};
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
  }
`

export const placeholder = css`
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_regular};
  ${font_md};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const inlineAction = css`
  color: ${base_colorAction};
  font-family: ${font_family_weight_medium};
  ${font_md};
  position: absolute;
  right: ${spacing(5)};
`

export const content = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${spacing(2.5)};
  min-width: 0;
`

export const field = css`
  align-self: stretch;
  background: ${base_colorSurfaceSecondary};
  border: 1px solid ${input_borderActive};
  border-radius: ${cornerRadius};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: ${spacing(35)};
  padding: ${spacing(4)} ${spacing(5)};
  position: relative;
`

export const textarea = css`
  align-self: stretch;
  background: transparent;
  border: 0;
  color: ${text_colorTextPrimary};
  display: flex;
  flex: 1;
  flex-shrink: 0;
  font-family: ${font_family_weight_regular};
  ${font_md};
  min-height: 0;
  min-width: 0;
  outline: none;
  padding: 0 0 ${spacing(13)};
  resize: none;
  width: 100%;

  &::placeholder {
    color: ${text_colorTextSecondary};
  }
`

export const actions = css`
  align-items: center;
  display: flex;
  gap: ${spacing(2)};
  height: ${spacing(10)};
  justify-content: flex-end;
  position: absolute;
  right: ${spacing(3)};
  top: ${spacing(22)};
`

export const error = css`
  margin: 0;
`

export const visuallyHidden = css`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const status = css`
  ${visuallyHidden};
`
